import cn from './cn.js';

const palette = [
  'bg-indigo-100 text-indigo-700',
  'bg-emerald-100 text-emerald-700',
  'bg-sky-100 text-sky-700',
  'bg-amber-100 text-amber-800',
  'bg-rose-100 text-rose-700',
  'bg-purple-100 text-purple-700',
];

function hash(str = '') {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) % 1000003;
  return h;
}

export function initialsFor(name = '', email = '') {
  const source = (name || '').trim() || (email || '').split('@')[0] || '?';
  const parts = source.replace(/[._-]+/g, ' ').split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
}

/** Initials avatar. */
export default function Avatar({ name, email, src, size = 'md', className, inverted = false }) {
  const sizes = { xs: 'h-6 w-6 text-2xs', sm: 'h-7 w-7 text-xs', md: 'h-8 w-8 text-xs', lg: 'h-10 w-10 text-sm', xl: 'h-12 w-12 text-base' };
  const key = email || name || '';
  const color = inverted ? 'bg-white/15 text-white ring-1 ring-white/20' : palette[hash(key) % palette.length];
  if (src) {
    return <img src={src} alt={name || email || ''} className={cn('shrink-0 rounded-full object-cover', sizes[size] || sizes.md, className)} />;
  }
  return (
    <span className={cn('inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold uppercase', sizes[size] || sizes.md, color, className)} aria-hidden="true">
      {initialsFor(name, email)}
    </span>
  );
}
